import { IdValueType } from "src/app/core/helpers/indexables.helpers";

export type TableFieldType = 'string' | 'options' | 'image' | 'date' | 'boolean' | 'number' | 'phone' | 'email' | 'city';

export interface TableField {
  name: string;
  type: TableFieldType;
  label: string;
  protected?: boolean;
  required?: boolean;
  group?: string;
  options?: string
}

export const TABLE_FIELD_OPTIONS: { [index: string]: (IdValueType | string)[] } = {
  scholarity: [
    { id: 'a1', value: 'Nenhum' },
    { id: 'a2', value: 'Fundamental Completo (1ª a 9ª série)' },
    { id: 'a21', value: 'Fundamental Incompleto (1ª a 9ª série)' },
    { id: 'a3', value: 'Médio Completo (1º ao 3º ano)' },
    { id: 'a31', value: 'Médio Incompleto(1º ao 3º ano)' },
    { id: 'a4', value: 'Superior Completo (Faculdade)' },
    { id: 'a41', value: 'Superior Incompleto (Faculdade)' },
    { id: 'a5', value: 'Pós Graduação' },
    { id: 'a6', value: 'Mestrado' },
    { id: 'a7', value: 'Doutorado' },
    { id: 'a8', value: 'Pós Doutorado' }
  ],
  gender: [
    { id: 'M', value: 'Masculino' },
    { id: 'F', value: 'Feminino' }
  ],
  foot_type: [
    { id: 'R', value: 'Destro' },
    { id: 'L', value: 'Canhoto' },
    { id: 'B', value: 'Ambidestro' }
  ],
  blood_type: ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'],
  referees_activities: [
    { id: '1', value: 'Árbitro Principal' },
    { id: '2', value: 'Árbitro Auxiliar' },
    { id: 'N', value: 'Anotador' },
    { id: 'C', value: 'Cronometrista' },
    { id: 'R', value: 'Representante' },
    { id: 'O', value: 'Outros' }
  ],
  field_position: ['Ala', 'Fixo', 'Goleiro', 'Pivô', 'Ala - Pivô'],
  uniform_size: ['PP', 'P', 'M', 'G', 'GG', 'EXG', '4G', '5G'],
  BRA_UFS: [
    { id: 'AC', value: 'Acre' },
    { id: 'AL', value: 'Alagoas' },
    { id: 'AP', value: 'Amapá' },
    { id: 'AM', value: 'Amazonas' },
    { id: 'BA', value: 'Bahia' },
    { id: 'CE', value: 'Ceará' },
    { id: 'DF', value: 'Distrito Federal' },
    { id: 'ES', value: 'Espírito Santo' },
    { id: 'GO', value: 'Goiás' },
    { id: 'MA', value: 'Maranhão' },
    { id: 'MT', value: 'Mato Grosso' },
    { id: 'MS', value: 'Mato Grosso do Sul' },
    { id: 'MG', value: 'Minas Gerais' },
    { id: 'PA', value: 'Pará' },
    { id: 'PB', value: 'Paraíba' },
    { id: 'PR', value: 'Paraná' },
    { id: 'PE', value: 'Pernambuco' },
    { id: 'PI', value: 'Piauí' },
    { id: 'RJ', value: 'Rio de Janeiro' },
    { id: 'RN', value: 'Rio Grande do Norte' },
    { id: 'RS', value: 'Rio Grande do Sul' },
    { id: 'RO', value: 'Rondônia' },
    { id: 'RR', value: 'Roraima' },
    { id: 'SC', value: 'Santa Catarina' },
    { id: 'SP', value: 'São Paulo' },
    { id: 'SE', value: 'Sergipe' },
    { id: 'TO', value: 'Tocantins' }
  ]
}

const RG_FIELD: TableField = { name: 'rg', label: 'RG', type: 'string', protected: true, required: true };
const GENDER_FIELD: TableField = { name: 'gender', label: 'Genero/sexo', type: 'options', protected: true, required: true };
const BLOOD_TYPE_FIELD: TableField = { name: 'blood_type', label: 'Tipo Sanguineo', type: 'options' };
const UF_FIELD: TableField = { name: 'current_uf', label: 'UF Atual', type: 'options', options: 'key=BRA_UFS' };
const AddressFields: TableField[] = [

  { name: 'state', label: 'Estado', type: 'string', group: 'address' },
  { name: 'city', label: 'Cidade', type: 'string', group: 'address' },
  { name: 'street', label: 'Rua', type: 'string', group: 'address' },
  { name: 'number', label: 'numero residencia', type: 'string', group: 'address' },
  { name: 'zip_code', label: 'CEP', type: 'string', group: 'address' },
  { name: 'neighborhood', label: 'Bairro', type: 'string', group: 'address' }
];

export const ENTITY_FIELDS: TableField[] = [
  { name: 'name', label: 'Nome Completo', type: 'string', protected: true, required: true },
  // { name: 'document', label: 'CPF/CNPJ', type: 'string', protected: true, required: true },
  { name: 'nickname', label: 'Apelido/Nome Fantasia', type: 'string', protected: true, required: true },
  { name: 'email', label: 'Email', type: 'email', protected: true, required: true },
  { name: 'photo_url', label: 'Imagem de perfil', type: 'image', protected: true },
  { name: 'birth', label: 'Nascimento/Constituição', type: 'date', required: true },
  { name: 'validated', label: 'Perfil validado', type: 'boolean', protected: true },
  { name: 'self_user', label: 'Usuário Vinculado', type: 'number', protected: true },
  { name: 'born_city', label: 'Naturalidade', type: 'string' },
  { name: 'scholarity', label: 'Escolaridade', type: 'options' },
  { name: 'mobile_phone', label: 'Telefone Celular', type: 'phone', required: true },
  { name: 'contact_phone', label: 'Telefone para contatos', type: 'phone' },
  { name: 'residential_phone', label: 'Telefone Residencial', type: 'phone' },
]


export const USER_FIELDS: TableField[] = [].concat(ENTITY_FIELDS).concat(...[
  GENDER_FIELD,
  RG_FIELD,
  { name: 'nationality', label: 'Nacionalidade', type: 'string' },
  { name: 'father_name', label: 'Nome do Pai', type: 'string' },
  { name: 'mother_name', label: 'Nome da Mãe', type: 'string' },
  { name: 'profession', label: 'Profissão', type: 'string' },
  { name: 'company', label: 'Empresa atual', type: 'string' },
]);

export const CONTRIBUTOR_FIELDS: TableField[] = [].concat(ENTITY_FIELDS).concat(...[
  RG_FIELD,
  GENDER_FIELD,
  BLOOD_TYPE_FIELD,
  { name: 'activities', label: 'Atividades desempenhadas', type: 'string' },
  { name: 'crm', label: 'Numero do CRM', type: 'string' },
  { name: 'crm_uf', label: 'UF do CRM', type: 'string' },
]);

export const REFEREES_FIELDS: TableField[] = [].concat(ENTITY_FIELDS).concat(...[
  RG_FIELD,
  GENDER_FIELD,
  BLOOD_TYPE_FIELD,
  { name: 'weight', label: 'Peso', type: 'number' },
  { name: 'height', label: 'Altura', type: 'number' },
  UF_FIELD,
  { name: 'graduation_year', label: 'Ano de graduação', type: 'year:min=1950;max=current' },
  { name: 'national_board_year', label: 'Ano entrada quadro nacional', type: 'year:min=1950;max=current' },
  { name: 'uniform', label: 'Uniforme', type: 'string' },
  { name: 'monthly_income', label: 'Renda média mensal', type: 'currency' },
  { name: 'acting_region', label: 'Região de atuação', type: 'string' },
  { name: 'activities', label: 'Atividades de atuação', type: 'options:key=referees_activities' },

]);

export const ATHLETES_FIELDS: TableField[] = [].concat(ENTITY_FIELDS).concat(...[
  RG_FIELD,
  { name: 'weight', label: 'Peso', type: 'number' },
  { name: 'height', label: 'Altura', type: 'number' },
  BLOOD_TYPE_FIELD,
  UF_FIELD,
  { name: 'father_name', label: 'Nome do Pai', type: 'string' },
  { name: 'mother_name', label: 'Nome da Mãe', type: 'string' },
  { name: 'field_position', label: 'Posição em campo', type: 'options' },
  { name: 'foot_type', label: 'Pé de preferencia', type: 'options' },
  { name: 'document_foreigner', label: 'ID Estrangeiro', type: 'string', protected: true, required: true },
  { name: 'foreigner', label: 'Estrangeiro', type: 'boolean', protected: true },
]);

export const CLUBS_FIELDS: TableField[] = [].concat(ENTITY_FIELDS).concat(...[
  { name: 'primary_phone', label: 'telefone Principal', type: 'phone' },
])
export const LEAGUES_FIELDS: TableField[] = [].concat(ENTITY_FIELDS).concat(...[
  { name: 'primary_phone', label: 'telefone Principal', type: 'phone' },
])

export const SCHOOLS_FIELDS: TableField[] = [].concat(ENTITY_FIELDS).concat(...[
  { name: 'primary_phone', label: 'telefone Principal', type: 'phone' },
])

export const TEACHERS_FIELDS: TableField[] = [].concat(ENTITY_FIELDS).concat(...[
  RG_FIELD,
  UF_FIELD,
  GENDER_FIELD,
  BLOOD_TYPE_FIELD
]);

export const TABLE_FIELDS: { [index: string]: TableField[] } = {
  entities: ENTITY_FIELDS,
  users: USER_FIELDS,
  referees: REFEREES_FIELDS,
  athletes: ATHLETES_FIELDS,
  clubs: CLUBS_FIELDS,
  leagues: LEAGUES_FIELDS,
  schools: SCHOOLS_FIELDS,
  teachers: TEACHERS_FIELDS
}
